/**
 * <Upgrade 
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';

import './Upgrade.scss';

import handshake from './images/handshake.jpg';
import community from './images/community.jpg';


const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => {
  return {

  };
};

class Upgrade extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
  
  }
  
  render() {
    return (
      <div className='Upgrade'>

        <div className='Upgrade--content'>
          <div className='Upgrade--content--section' style={{ backgroundImage: `url(${handshake})` }}></div>
          <div className='Upgrade--content--section'>
            <div className='Panel'>
              <h2>Secure Payment Area</h2>
              <p>Pellentesque egestas, neque sit amet convallis pulvinar, justo nulla eleifend augue, ac auctor orci leo non est. Sed hendrerit. Vivamus quis mi. Nam adipiscing. Maecenas vestibulum mollis diam.</p>
            </div>
          </div>
        </div>
        <div className='Upgrade--content'>
          <div className='Upgrade--content--section align-right'>
            <div className='Panel'>
              <h2>没有ClasstopBase就别想开学校了。<br/>已经有学校了？<br/>关了得了。</h2>
                <p>Pellentesque egestas, neque sit amet convallis pulvinar, justo nulla eleifend augue, ac auctor orci leo non est. Sed hendrerit. Vivamus quis mi. Nam adipiscing. Maecenas vestibulum mollis diam.</p>
            </div>
          </div>
          <div className='Upgrade--content--section' style={{ backgroundImage: `url(${community})` }}></div>
        </div>
      
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Upgrade);



// WEBPACK FOOTER //
// ./src/containers/pages/Upgrade/index.js